import { logger, sanitizeError } from '@heidi/runtime/logger';
import { useMutation } from '@tanstack/react-query';

import { activateHeidi2 } from '../api/billing';
import { invalidateCreditAllowance } from '../query/useQueryCreditAllowance';
import { invalidateCurrentUserBillingInfo } from '../query/useQueryUserBillingInfo';

export type UseMutateActivateHeidi2Props = {
  onActivated?: () => void;
  onActivationError?: () => void;
};

export function useMutateActivateHeidi2({
  onActivated,
  onActivationError,
}: UseMutateActivateHeidi2Props = {}) {
  return useMutation({
    mutationFn: activateHeidi2,
    onSuccess: async () => {
      // Activation provisions the Heidi 2 allowance; a null `/credit-allowance`
      // cached before it lands would otherwise hide the usage popover for 5 min.
      // A refresh failure only logs — activation already succeeded, so
      // surfacing it as a mutation error would be a lie.
      try {
        await Promise.all([
          invalidateCurrentUserBillingInfo(),
          invalidateCreditAllowance(),
        ]);
      } catch (error: unknown) {
        logger.error(
          'Failed to refresh billing and credit allowance after Heidi 2 activation',
          sanitizeError(error)
        );
      }
      onActivated?.();
    },
    onError: () => onActivationError?.(),
  });
}
